import { errorHandler } from '@/helpers/utils'
import { useImageSelectionApproval } from '../queries/use-image-selection-approval'
import type { RemoveImagesFlagData } from '../queries/use-remove-images-flag'
import { usePhotosetStore } from '../store/store'
import type { Photoset, PhotosetSpace } from '../types'

export const useRemoveRetouchingQaFlag = ({
	photosetId,
	photosetSpaceId
}: {
	photosetId: Photoset['id']
	photosetSpaceId: PhotosetSpace['id']
}) => {
	const images = usePhotosetStore((state) => state.images)

	const { mutate: sendBackImage } = useImageSelectionApproval({
		photosetId,
		photosetSpaceId,
		options: {
			onError: (error) => errorHandler(error)
		}
	})

	const onRemoveFlagCb = (variables: RemoveImagesFlagData) => {
		for (const imageId of variables.imageIds) {
			const image = images.get(imageId)
			const newFlagsList = image?.flags.filter(
				(flag) =>
					flag.key_name !== variables.flag.key_name &&
					flag.type === 'visual_retouching'
			)

			if (newFlagsList?.length === 0 && image) {
				sendBackImage({
					imageId: image.id,
					needs_to_review: false
				})
			}
		}
	}

	return {
		onRemoveFlagCb,
		sendBackImage
	}
}
